var myVideo = document.getElementById('WendecoverVideo')

function playPause() {
  if (myVideo.paused) myVideo.play()
  else myVideo.pause()
}
